module.exports = __webpack_public_path__ + "img/question-mark.6bf79c8a.svg";